import { useTranslation } from "react-i18next";
import type { Crumb } from "./PageBreadcrumbs";

/** The top-level destinations every breadcrumb trail starts from. */
export function useAreaCrumbs(): Record<"home" | "build" | "spaces" | "settings" | "admin" | "help", Crumb> {
  const { t } = useTranslation(["shell", "settings", "admin", "help"]);
  return {
    home: { label: t("shell:sidebar.home"), to: "/" },
    build: { label: t("shell:routes.build"), to: "/build" },
    spaces: { label: t("shell:routes.spaces"), to: "/spaces" },
    settings: { label: t("settings:title"), to: "/settings" },
    admin: { label: t("admin:title"), to: "/admin" },
    help: { label: t("help:title"), to: "/help" },
  };
}
